._selectItem_1ntdm_1._selectItem_1ntdm_1._selectItem_1ntdm_1{box-sizing:border-box;display:grid;grid-template-areas:"decL label decR generated" "_1 desc _2 _3";grid-template-columns:auto minmax(0,1fr) auto auto;width:100%}
